/**
 * v-safe-html — Diretiva que sanitiza HTML antes de renderizar
 *
 * Substitui v-html com proteção contra XSS via DOMPurify.
 *
 * @example
 * <!-- Em vez de: -->
 * <div v-html="userContent"></div>
 *
 * <!-- Use: -->
 * <div v-safe-html="userContent"></div>
 */
import DOMPurify from 'dompurify'

export const safeHtml = {
  bind(el, binding) {
    el.innerHTML = binding.value ? DOMPurify.sanitize(binding.value) : ''
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = binding.value ? DOMPurify.sanitize(binding.value) : ''
    }
  }
}

export default safeHtml
